import React, { useEffect, useState } from "react";
import "./offerContent.scss"
import { navigate } from "gatsby";
import warningSvg from "../../../../src/assets/images/icons/warning-icon.svg";
import ToastAdvertiser from "../../atoms/toast-advertiser/toastAdvertiser";
interface PageInfoInterface {
    objetivo: string,
    tipo_formacion: string,
    contenido: string,
    dirigido_a: string,
    tener_cuenta: string,
    habilidades_adquiridas: string,
    certificado: number,
    foto_desktop: string,
    invitado: string,
    resena_invitado: string,
    foto_card_desktop: string
};

const OfferContent = () => {
    const [pageInfo, setPageInfo] = useState<pageInfoInterface>({foto_card_desktop:"",resena_invitado:"", invitado:"", foto_desktop: "", objetivo:"", tipo_formacion:"", contenido:"", dirigido_a:"", tener_cuenta:"", habilidades_adquiridas:"", certificado:0});

    useEffect (()=> {
        const courseInfo : string | null = localStorage.getItem("curso");
        courseInfo ? setPageInfo(JSON.parse(courseInfo)) : navigate("/personas/aprendizaje/oferta");
    }, []);

    return (
        <section className={`o-offer-content ${pageInfo.tipo_formacion === "MasterClass" && "o-offer-content__objective-content-container without-margin"}`}>
            <div className="o-offer-content__objective CabeceraInternaOferta" id="CabeceraInternaOferta0">
                <h3 className="o-offer-content__objective-title">Objetivo</h3>
                <p className="o-offer-content__objective-description">{pageInfo.objetivo}</p>
            </div>
            { pageInfo.tipo_formacion === "MasterClass" ?
                pageInfo.invitado.includes(" ^ ") ?
                    <div className="o-offer-content__masterclass-container">
                        {
                            pageInfo.invitado.split(" ^ ").map((_, index)=>{
                                return(
                                    <div className="o-offer-content__masterclass">
                                        <img 
                                            className="o-offer-content__masterclass-face" 
                                            alt="Imágen rostro tutor" 
                                            src={pageInfo.foto_card_desktop.split(" ^ ")[index]}
                                        />
                                        <div>
                                            <div className="o-offer-content__masterclass-name">
                                                <h4 className="o-offer-content__objective-title">{pageInfo.invitado.split(" ^ ")[index]}</h4>
                                                <span className="o-offer-content__masterclass-label">Invitado</span>
                                            </div>
                                            <p className="o-offer-content__objective-description">{pageInfo.resena_invitado.split(" ^ ")[index]}</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                :
                pageInfo.invitado.includes(" ^ ") ?
                    <div className="o-offer-content__masterclass-container">
                        {
                            pageInfo.invitado.split(" ^ ").map((_, index)=>{
                                return(
                                    <div className="o-offer-content__masterclass">
                                        <img 
                                            className="o-offer-content__masterclass-face" 
                                            alt="Imágen rostro tutor" 
                                            src={pageInfo.foto_card_desktop.split(" ^ ")[index]}
                                        />
                                        <div>
                                            <div className="o-offer-content__masterclass-name">
                                                <h4 className="o-offer-content__objective-title">{pageInfo.invitado.split(" ^ ")[index]}</h4>
                                                <span className="o-offer-content__masterclass-label">Invitado</span>
                                            </div>
                                            <p className="o-offer-content__objective-description">{pageInfo.resena_invitado.split(" ^ ")[index]}</p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                :
                    <div className="o-offer-content__masterclass">
                        <img 
                            className="o-offer-content__masterclass-face" 
                            alt="Imágen rostro tutor" 
                            src={pageInfo.foto_card_desktop}
                        />
                        <div>
                            <div className="o-offer-content__masterclass-name">
                                <h4 className="o-offer-content__objective-title">{pageInfo.invitado}</h4>
                                <span className="o-offer-content__masterclass-label">Invitado</span>
                            </div>
                            <p className="o-offer-content__objective-description">{pageInfo.resena_invitado}</p>
                        </div>
                    </div>
            :
                <>
                    <div className="o-offer-content__content o-offer-content__content-lile CabeceraInternaOferta" id="CabeceraInternaOferta1">
                        <h3 className="o-offer-content__objective-title">Contenido</h3>
                        <div className="o-offer-content__content-container">
                            {pageInfo.contenido && pageInfo.contenido.split("\r\n").map((item)=>
                                <div className="o-offer-content__content-item">
                                    <img alt="Icono escudo" src="https://images.ctfassets.net/203frbsx1z3n/6ecbGtQirg0bVow1EEA8bM/2af4eb7b06109af180540c82a31fb3dc/verificacion-de-escudo__1_.svg"/>
                                    <span>{item}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="o-offer-content__objective-content-container CabeceraInternaOferta">
                        <div className="o-offer-content__objective" id="CabeceraInternaOferta2">
                            <h3 className="o-offer-content__objective-title">A quién va dirigido</h3>
                            <p className="o-offer-content__objective-description">{pageInfo.dirigido_a}</p>
                        </div>
                        <div className="o-offer-content__content" id="CabeceraInternaOferta3">
                            <h3 className="o-offer-content__objective-title">Qué debes tener en cuenta</h3>
                            <div className="o-offer-content__content-container">
                                {pageInfo.tener_cuenta && pageInfo.tener_cuenta.split("\r\n").map((item)=>
                                    <div className="o-offer-content__content-item">
                                        <img className="o-offer-content__content-item-check" alt="Icono escudo" src="https://images.ctfassets.net/203frbsx1z3n/6qb6CZUbTwNuEPe3c8QCrj/5934fe3c2454149266ab1a246949bc09/icon_chek2.svg"/>
                                        <span>{item}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="o-offer-content__content o-offer-content__content-gray CabeceraInternaOferta" id="CabeceraInternaOferta4">
                        <h3 className="o-offer-content__objective-title">Habilidades que vas adquirir</h3>
                        <div className="o-offer-content__content-container">
                            {pageInfo.habilidades_adquiridas && pageInfo.habilidades_adquiridas.split("\r\n").map((item)=>
                                <div className="o-offer-content__content-item">
                                    <img className="o-offer-content__content-item-check" alt="Icono escudo" src="https://images.ctfassets.net/203frbsx1z3n/6qb6CZUbTwNuEPe3c8QCrj/5934fe3c2454149266ab1a246949bc09/icon_chek2.svg"/>
                                    <span>{item}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="o-offer-content__objective CabeceraInternaOferta" id="CabeceraInternaOferta5">
                        <h3 className="o-offer-content__objective-title">Certificación</h3>
                        {pageInfo.certificado >= 1 ? 
                            <div>
                                <p className="o-offer-content__objective-description">Los certificados emitidos por COMFAMA son constancias de asistencia, otorgadas a quienes hayan participado en al menos el 80% de las horas totales de la formación y hayan cumplido satisfactoriamente con al menos el 80% de las actividades propuestas durante el proceso formativo. </p>
                                <br></br>
                                <p className="o-offer-content__objective-description">Los cursos y talleres ofrecidos por COMFAMA tienen una duración inferior a 160 horas, por lo tanto, corresponden a una oferta de educación informal, cuyo objetivo es brindar oportunidades para complementar, actualizar, perfeccionar, renovar o profundizar conocimientos y habilidades. </p>
                            </div>
                        : 
                            <p className="o-offer-content__objective-description">No</p>
                        }
                    </div>
                </>
            }
        </section>
    );
};

export default OfferContent;